module.exports = __webpack_public_path__ + "img/no-content.b33e7499.svg";